package com.example.histoire.web

enum class UserFacingErrorKind {
    GroqLimit,
    Network,
    Reportable,
}

data class UserFacingError(
    val kind: UserFacingErrorKind,
    val message: String,
    val technicalDetails: String,
)

fun frenchUserFacingError(raw: String?): UserFacingError {
    val details = raw?.trim().orEmpty()
    val text = details.lowercase()

    val isGroqLimit =
        "429" in text ||
            "quota" in text ||
            "rate limit" in text ||
            "too many requests" in text ||
            "groq http 429" in text
    if (isGroqLimit) {
        return UserFacingError(
            kind = UserFacingErrorKind.GroqLimit,
            message =
                "Le service de generation est temporairement sature (limite atteinte). " +
                    "Reessaie dans quelques minutes.",
            technicalDetails = details,
        )
    }

    val isNetwork =
        "network" in text ||
            "failed to fetch" in text ||
            "timeout" in text ||
            "timed out" in text ||
            "dns" in text ||
            "offline" in text ||
            "socket" in text ||
            "connect" in text
    if (isNetwork) {
        return UserFacingError(
            kind = UserFacingErrorKind.Network,
            message =
                "Impossible de contacter le serveur pour l'instant. " +
                    "Verifie ta connexion puis reessaie.",
            technicalDetails = details,
        )
    }

    val msg =
        when {
            "unauthorized" in text || "forbidden" in text || "jwt" in text ->
                "La session semble invalide ou expiree. Recharge la page puis reconnecte-toi."
            "500" in text || "502" in text || "503" in text || "504" in text ->
                "Le serveur rencontre un probleme temporaire. Reessaie dans un instant."
            else ->
                "Une erreur inattendue est survenue."
        }
    return UserFacingError(
        kind = UserFacingErrorKind.Reportable,
        message = msg,
        technicalDetails = details,
    )
}

fun toFrenchUserFacingMessage(raw: String?, fallback: String): String {
    val source = raw?.trim().orEmpty()
    if (source.isBlank()) return fallback
    return frenchUserFacingError(source).message
}
